/**
 * GoodFunds embedded-webform theme bridge.
 *
 * The webform is embedded cross-origin (iframe) into the GoodFunds website,
 * which supports light/dark. We receive the desired theme two ways:
 *   1. initial — `?theme=dark|light` on the iframe URL (no FOUC), defaulting
 *      to light when absent so legacy embeds stay light.
 *   2. live    — postMessage {type:'gf-theme', theme} when the parent toggles.
 * and reflect it by toggling Gin's `.gin--dark-mode` class on <html>, which
 * drives both Gin's native widgets and our scoped `--gf-*` tokens.
 *
 * Runs only on the webform share page so it never flips Gin's dark mode on
 * other pages rendered by this theme (e.g. the editor UI).
 */
(function (window, document) {
  'use strict';

  if (!document.documentElement.classList.contains('webform-share-page-html')) {
    return;
  }

  var DARK_CLASS = 'gin--dark-mode';

  function apply(theme) {
    var root = document.documentElement;
    if (theme === 'dark') {
      root.classList.add(DARK_CLASS);
    } else if (theme === 'light') {
      root.classList.remove(DARK_CLASS);
    }
  }

  function fromUrl() {
    var match = /[?&]theme=(dark|light)\b/.exec(window.location.search);
    return match ? match[1] : null;
  }

  // 1. Initial theme: URL param wins, otherwise default to light. We do NOT
  // fall back to the viewer's OS preference, because existing embeds that
  // predate theming carry no `?theme=` param and must stay light regardless of
  // the visitor's dark-mode setting. Opt into dark explicitly via `?theme=dark`
  // (or a live `gf-theme` message from the parent).
  var initial = fromUrl() || 'light';
  apply(initial);

  // 2. Live updates from the parent window on toggle.
  // Origin is intentionally not restricted: this message only toggles a CSS
  // class (light/dark) — it touches no data and grants no capability, so the
  // worst an arbitrary embedder could do is re-theme the form they embed. We
  // validate the message shape strictly instead.
  window.addEventListener('message', function (event) {
    var data = event.data;
    if (data && data.type === 'gf-theme' && (data.theme === 'dark' || data.theme === 'light')) {
      apply(data.theme);
    }
  });
})(window, document);
